import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timeout = window.setTimeout(() => setDebounced(value), delayMs)
        return () => window.clearTimeout(timeout)
    }, [value, delayMs])

    return debounced
}
